import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Tickets } from './pages/Tickets';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/tickets" replace />} />
        <Route path="/tickets" element={<Tickets />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
